import { buttonClicked, fetchImages } from '../redux/imagesSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import GameHeader from './gameUiElements/GameHeaderComponent';

const ButtonBar = ({ func, displayed }) => {
    if (displayed) {
        return (
            <div className="flex justify-center px-6 pb-6 pt-3">
                <button
                    className="
                        w-full max-w-xs h-16 rounded-2xl
                        bg-[#0F172A] hover:bg-[#111827] text-white font-bold text-lg
                        shadow-[0_4px_14px_rgba(15,23,42,0.3)]
                        active:scale-95 transition-all duration-200
                        flex items-center justify-center gap-2
                    "
                    onClick={func}
                    value="next"
                >
                    Next
                    <i className="fa-solid fa-arrow-right"></i>
                </button>
            </div>
        );
    }

    return (
        <div className="flex gap-3 px-6 pb-6 pt-3">
            <button
                className="
                    flex-1 h-16 rounded-2xl
                    bg-[#EDE9FE] hover:bg-[#DDD6FE] text-[#0F172A] font-bold text-lg
                    border border-[#CBD5E1]
                    shadow-[0_4px_14px_rgba(203,213,225,0.3)]
                    active:scale-95 transition-all duration-200
                    flex items-center justify-center gap-2
                "
                onClick={func}
                value="kid"
            >
                <i className="fa-solid fa-child text-xl"></i>
                Kid
            </button>
            <button
                className="
                    flex-1 h-16 rounded-2xl
                    bg-[#CCFBF1] hover:bg-[#99F6E4] text-[#0F172A] font-bold text-lg
                    border border-[#CBD5E1]
                    shadow-[0_4px_14px_rgba(203,213,225,0.3)]
                    active:scale-95 transition-all duration-200
                    flex items-center justify-center gap-2
                "
                onClick={func}
                value="dog"
            >
                <i className="fa-solid fa-paw text-xl"></i>
                Dog
            </button>
        </div>
    );
};

function GameNew() {
    let { quiz_id } = useParams();
    if (!quiz_id) {
        quiz_id = 0;
    }

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const NUMBER_OF_IMAGES = 10;

    const imagesCount = useSelector((state) => state.imageClicked.imageCount);
    const imagesArray = useSelector((state) => state.imageClicked.imagesArray);
    const resultsArray = useSelector((state) => state.imageClicked.resultsArray);
    const imageToDisplay = useSelector((state) => state.imageClicked.currentImage);
    const isRight = useSelector((state) => state.imageClicked.isRight);

    const displayed = useSelector((state) => {
        if (state.imageClicked.imagesArray.length !== 0 && imagesCount < 10) {
            return state.imageClicked.imagesArray[imagesCount].displayed;
        }
        return false;
    });

    const revealedAnswer = useSelector((state) => {
        if (
            state.imageClicked.imagesArray.length !== 0 &&
            imagesCount < 10 &&
            state.imageClicked.imagesArray[imagesCount].displayed
        ) {
            return state.imageClicked.imagesArray[imagesCount].result;
        }
        return null;
    });

    useEffect(() => {
        if (imagesCount === 10) {
            navigate('/recap', { replace: true });
        }
    }, [imagesCount, navigate]);

    useEffect(() => {
        dispatch(fetchImages({ quiz_id: quiz_id }));
    }, [dispatch, quiz_id]);

    const [showExitConfirm, setShowExitConfirm] = useState(false);

    const manageClick = (eventRecieved) => {
        dispatch(buttonClicked(eventRecieved.currentTarget.value));
    };

    // Image container styling based on answer state
    let imageContainerClass =
        'rounded-2xl overflow-hidden transition-all duration-300';
    if (displayed && isRight) {
        imageContainerClass +=
            ' ring-4 ring-emerald-400 shadow-[0_0_20px_rgba(52,211,153,0.4)]';
    } else if (displayed && !isRight) {
        imageContainerClass +=
            ' ring-4 ring-red-400 shadow-[0_0_20px_rgba(248,113,113,0.4)]';
    }

    // Loading state
    if (imagesArray.length === 0) {
        return (
            <div className="h-[100dvh] flex flex-col bg-gradient-to-b from-[#F5F3FF] to-[#F0FDFA] overflow-hidden">
                <GameHeader
                    imagesArray={[]}
                    imagesCount={0}
                    numbOfQuestions={NUMBER_OF_IMAGES}
                    resultsArray={{}}
                    isRight={false}
                    displayed={false}
                />
                <div className="flex-1 flex items-center justify-center">
                    <div className="text-center">
                        <div className="w-12 h-12 border-4 border-slate-200 border-t-[#0F172A] rounded-full animate-spin mx-auto mb-4"></div>
                        <p className="text-[#334155] font-medium">
                            Loading game...
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="h-[100dvh] flex flex-col bg-gradient-to-b from-[#F5F3FF] to-[#F0FDFA] overflow-hidden">
            {/* Header with segmented progress */}
            <GameHeader
                imagesArray={imagesArray}
                imagesCount={imagesCount}
                numbOfQuestions={NUMBER_OF_IMAGES}
                resultsArray={resultsArray}
                isRight={isRight}
                displayed={displayed}
                onLogoClick={() => setShowExitConfirm(true)}
            />

            {/* Exit confirmation modal */}
            {showExitConfirm && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm px-6">
                    <div className="bg-white rounded-2xl shadow-xl p-6 max-w-sm w-full text-center">
                        <p className="text-[#0F172A] font-bold text-lg mb-2">Leave game?</p>
                        <p className="text-[#334155] text-sm mb-5">You'll lose your progress in this round.</p>
                        <div className="flex gap-3">
                            <button
                                className="flex-1 h-12 rounded-xl bg-gray-100 hover:bg-gray-200 text-[#0F172A] font-semibold transition-colors"
                                onClick={() => setShowExitConfirm(false)}
                            >
                                Stay
                            </button>
                            <button
                                className="flex-1 h-12 rounded-xl bg-[#0F172A] hover:bg-[#111827] text-white font-semibold transition-colors"
                                onClick={() => navigate('/')}
                            >
                                Leave
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Image area */}
            <div className="flex-1 flex flex-col items-center justify-center px-4 py-2 min-h-0">
                <div className={imageContainerClass + ' max-h-full w-fit'}>
                    <img
                        src={imageToDisplay}
                        className="block max-h-[calc(100dvh-240px)] w-auto"
                        alt="Kid or Dog?"
                    />
                </div>
                <p className={`font-title text-xl mt-2 py-1 font-bold ${displayed && revealedAnswer ? (isRight ? 'text-emerald-600' : 'text-red-500') : 'invisible'}`}>
                    It's a {revealedAnswer === 'kid' ? 'Kid' : 'Dog'}!
                </p>
            </div>

            {/* Button area */}
            <ButtonBar func={manageClick} displayed={displayed} />
        </div>
    );
}

export default GameNew;
